export const HitCodes = {
  A: "Consumer requested security freeze on his/her credit file",
  G: "Consumer requested security freeze on his/her credit file",
  "L*": "Consumer requested Equifax lock on his/her credit file",
  "M*": "Consumer requested Equifax lock on his/her credit file"
};

export const errorHitCodes = ["A", "G", "L*", "M*", "I"];
